import React from 'react';
import PropTypes from 'prop-types';

class ProgressBar extends React.Component {
  render() {
    const percentage = (typeof this.props.percent === 'string' && this.props.percent.includes('%')) ? this.props.percent : `${this.props.percent}%`;
    const style = {};
    if (this.props.vertical) {
      style.height = percentage;
    } else {
      style.width = percentage;
    }
    const verticalness = this.props.vertical ? ' vertical' : '';
    const activeness = this.props.active ? ' active' : '';
    const stripedness = this.props.striped ? ' progress-bar-striped' : '';
    const size = this.props.size ? ` ${this.props.vertical ? 'progress-' : ''}${this.props.size}` : '';
    return (
      <div className={`progress${verticalness}${activeness}${size}`}>
        <div
          className={`progress-bar ${this.props.theme}${stripedness}`}
          role="progressbar"
          aria-valuenow={percentage.replace('%', '')}
          aria-valuemin="0"
          aria-valuemax="100"
          style={style}
        >
          <span className="sr-only">{`${percentage} Complete`}</span>
        </div>
      </div>
    );
  }
}

ProgressBar.propTypes = {
  percent: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  theme: PropTypes.string,
  size: PropTypes.string,
  striped: PropTypes.bool,
  vertical: PropTypes.bool,
  active: PropTypes.bool
};

ProgressBar.defaultProps = {
  theme: 'progress-bar-yellow',
  percent: 0,
  size: '',
  striped: false,
  vertical: false,
  active: false
};

export default ProgressBar;
